<template>
  <v-sheet >
  <v-system-bar
      color="background"
      height="20rem"
  >
    <!-- Filter Tipo informe -->
    <v-menu
        max-height="500"
        v-model="menuFilterReportType"
        bottom
        offset-y
        :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            v-bind="attrs"
            v-on="on"
        >
          <v-badge :color="textReportType && isModelReportSelected ? 'success' : 'transparent' " dot :bordered="!!textReportType && isModelReportSelected">
            <v-icon color="primary" class="mr-2" left>
              mdi-format-list-bulleted
            </v-icon>
            <span v-show="!isMobile">{{ $t('Global.Reports.report') }} </span>
          </v-badge>
        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group
            color="background"
            class="v-text-search-custom">
          <v-list-item>
            <v-text-field
                color="background"
                dense
                class="neu-input"
                v-model="searchReportType"
                :label="searchLabelText"
                hide-details/>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="background" v-model="modelReportType">
          <v-list-item
              max-height="240"
              style="overflow-y: auto;"
              color="primary"
              v-for="(item, index) in reportTypesList"
              :key="index.reportTypeId"
              @click="changeReportTypeData(item)"
          >
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title>{{ $t(`Global.Reports.literal_${item.reportTypeName}`) }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small v-show="textReportType && active">close</v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <!-- Filter Tipo granularidad -->
    <v-sheet v-show="!isDetailRetail ">
    <v-menu
        max-height="250"
        v-model="menuFilterGranularityType"
        bottom
        offset-y
        :close-on-content-click="false">

      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            v-bind="attrs"
            v-on="on"
        >
          <v-badge :color="textGranularityType ? 'success' : 'transparent' " dot :bordered="!!textGranularityType">
            <v-icon color="primary" class="mr-2" left>
              mdi-format-list-bulleted
            </v-icon>
            <span v-show="!isMobile">{{ $t('Global.Reports.granularity') }} </span>
          </v-badge>

        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group
            color="background"
            class="v-text-search-custom">
          <v-list-item>
            <v-text-field
                color="background"
                dense
                class="neu-input"
                v-model="searchGranularityType"
                :label="searchLabelText"
                hide-details/>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="background" v-model="modelGranularityType">
          <v-list-item
              max-height="240"
              style="overflow-y: auto;"
              color="primary"
              v-for="(item, index) in granularityTypesList"
              :key="index.granularityTypeName"
              @click="changeGranularityTypeData(item)"
          >
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title>{{ $t(`Global.Reports.literal_${item.granularityTypeName }`)  }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small v-show="textGranularityType && active">close</v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    </v-sheet>
    <!-- Filter Dates -->
    <v-sheet >
      <v-menu
          v-model="menuFiltersDate"
          offset-y
          :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
              small
              v-on="on"
              class="neu-glow mr-3"
              @click="cleanMenuDatePicker"
              color="background">

            <v-badge :color="Object.keys(dateSelected).length === 3 ? 'success' : 'transparent' "
                     dot
                     :bordered="Object.keys(dateSelected).length === 3">
              <v-icon color="primary" class="mr-2" left>
                mdi-format-list-bulleted
              </v-icon>
              <span v-show="!isMobile">{{ $t('Global.Reports.dates') }} </span>
            </v-badge>

          </v-btn>
        </template>
        <v-card color="background" class="card-dates px-4" >
          <vuse-section-definition
              :title="!isMobile ? $t('Global.Reports.time-ranges') : '' "
              icon="mdi-calendar-search"/>
          <v-sheet color="background" :class="dateRangeCSS">
            <v-sheet color="background" >
              <v-menu
                  ref="menu"
                  v-model="menuDatePicker"
                  :close-on-content-click="datesPiker.length === 2"
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-card color="background" flat >
<!--                    <v-card-subtitle v-if="isMobile">
                      {{ $t("Global.Reports.time-ranges-absolute") }}
                      <v-btn
                          fixed
                          right
                          small
                          plain
                          color="background"
                          @click="timeRangesExpandable = !timeRangesExpandable"
                      >
                        <v-icon color="primary" class="mr-2" left>
                          {{
                            timeRangesExpandable ? 'mdi-arrow-up-drop-circle-outline' :
                                'mdi-arrow-down-drop-circle-outline'
                          }}
                        </v-icon>
                        <span v-show="!isMobile">{{ textDate }} </span>
                      </v-btn>
                    </v-card-subtitle>-->
                    <v-card-text
                        transition="scale-transition"
                        v-show="showTimeRangesExpandable">
                      <v-text-field
                          :class="isMobile ? 'neu-input v-text-field-custom' : 'neu-input'"
                          v-model="datesPiker[0]"
                          :label="fromLabelText">
                        <template v-slot:append>
                          <v-btn
                              small
                              plain
                              v-on="on"
                              @click="menuDatePicker = true">
                            <v-icon>
                              mdi-calendar
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                      <v-text-field
                          :class="isMobile ? 'v-text-field-custom' : ''"
                          class="neu-input"
                          v-model="datesPiker[1]"
                          :label="toLabelText">
                        <template v-slot:append>
                          <v-btn
                              small
                              plain
                              v-on="on"
                              @click="menuDatePicker = true">
                            <v-icon>
                              mdi-calendar
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                </template>
                <v-date-picker
                    :locale="localeGeneral"
                    color="primary"
                    ref="picker"
                    no-title
                    range
                    @input="inputDatePicker"
                    :max="new Date().toISOString().substr(0, 10)"
                    v-model="datesPiker"/>
              </v-menu>
              <v-btn
                  v-show="showTimeRangesExpandable"
                  small
                  class="ml-3 mr-3 mb-3"
                  color="primary"
                  @click="rangeCustom"
                  :disabled="datesPiker.length !== 2"
              >
                {{ $t("Global.Reports.apply-time") }}
              </v-btn>
            </v-sheet>

<!--            <v-divider v-show="isMobile"/>-->

<!--            <v-sheet color="background">
              <v-card color="background" min-height="300" flat>
                <v-card-subtitle v-if="isMobile">
                  {{ $t("Global.DashboardBase.speed-ranges") }}
                </v-card-subtitle>
                <v-card-subtitle>
                  <v-text-field
                      :class="isMobile ? 'neu-input v-text-field-custom' : 'neu-input'"
                      v-model="searchRange"
                      :label="searchSpeedRangesLabelText()"
                      single-line
                      hide-details/>
                </v-card-subtitle>
                <v-card-text>
                  <v-list dense
                          max-height="200"
                          style="overflow-y: auto;"
                          color="background"
                          outlined>
                    <v-list-item-group color="background" v-model="modelFixedDate">
                      <v-list-item v-for="(item) in dateList"
                                   :key="item.key"
                                   :input-value="dateSelected.key"
                                   color="primary">
                        <v-list-item-content @click="rangeFixed(item)">
                          <v-list-item-title v-text="item.text"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-sheet>-->
          </v-sheet>
        </v-card>
        <v-btn
            icon
            absolute
            top
            right
            @click="closeMenuFilterDate"
        >
          <v-icon small>close</v-icon>
        </v-btn>
      </v-menu>
    </v-sheet>
    <!-- Filter Agente -->
    <v-sheet v-show="isDetailRetail ">
    <v-menu
        max-height="250"
        v-model="menuFilterAgentType"
        bottom
        offset-y
        :close-on-content-click="false">

      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            v-bind="attrs"
            v-on="on"
        >
          <v-badge :color="textAgentType ? 'success' : 'transparent' " dot :bordered="!!textAgentType">
            <v-icon color="primary" class="mr-2" left>
              mdi-format-list-bulleted
            </v-icon>
            <span v-show="!isMobile"> {{ $t('Global.Reports.agents') }} </span>
          </v-badge>

        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group
            color="background"
            class="v-text-search-custom">
          <v-list-item>
            <v-text-field
                color="background"
                dense
                class="neu-input"
                v-model="searchAgentType"
                :label="searchLabelText"
                hide-details/>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="background" v-model="modelAgentType">
          <v-list-item
              max-height="240"
              style="overflow-y: auto;"
              color="primary"
              v-for="(item, index) in agentsList"
              :key="index.agentId"
              @click="changeAgentData(item)"
          >
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title>{{ item.agentExtension }} - {{ item.agentName }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small v-show="textAgentType && active">close</v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    </v-sheet>
    <!-- Filter Tlf -->
    <v-sheet v-show="isDetailRetail ">
    <v-menu
        max-height="250"
        v-model="menuFilterTlf"
        bottom
        offset-y
        :close-on-content-click="false">

      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            v-bind="attrs"
            v-on="on"
        >
          <v-badge :color="tlf  ? 'success' : 'transparent' " dot :bordered="!!tlf">
            <v-icon color="primary" class="mr-2" left>
              mdi-format-list-bulleted
            </v-icon>
            <span v-show="!isMobile"> {{ $t('Global.Reports.tlf') }} </span>
          </v-badge>

        </v-btn>
      </template>
      <v-card color="background" class="" >
        <v-card-text color="background">
          <v-text-field
              @keyup.enter="changeTlf(false)"
              color="background"
              dense
              class="neu-input"
              hide-details
              v-model="tlf"
              :rules="[validTelephoneSpanishNumber]"
              :label="$t('Global.Reports.tlf')"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
              small
              class="mx-2"
              color="primary"
              @click="changeTlf(false)"
              :disabled="!isValidTelephoneSpanishNumber"
          >
            {{ $t('Global.Reports.apply') }}
          </v-btn>
          <v-spacer/>
          <v-btn
              icon
              small
              class="mx-2"
              color="primary"
              @click=" clearTlf()"
          >
            <v-icon  class="mr-2" left>
              mdi-eraser-variant
            </v-icon>
<!--            {{ $t('Global.Reports.apply') }}-->
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    </v-sheet>
<!-- Filter Cola -->
    <v-sheet v-show="isDetailRetail ">
    <v-menu
        max-height="250"
        v-model="menuFilterQueueType"
        bottom
        offset-y
        :close-on-content-click="false">

      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            v-bind="attrs"
            v-on="on"
        >
          <v-badge :color="textQueueType ? 'success' : 'transparent' " dot :bordered="!!textQueueType">
            <v-icon color="primary" class="mr-2" left>
              mdi-format-list-bulleted
            </v-icon>
            <span v-show="!isMobile"> {{ $t('Global.Reports.queues') }} </span>
          </v-badge>

        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group
            color="background"
            class="v-text-search-custom">
          <v-list-item>
            <v-text-field
                color="background"
                dense
                class="neu-input"
                v-model="searchQueueType"
                :label="searchLabelText"
                hide-details/>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="background" v-model="modelQueueType">
          <v-list-item
              max-height="240"
              style="overflow-y: auto;"
              color="primary"
              v-for="(item, index) in queuesList"
              :key="index.nodeId"
              @click="changeQueueData(item)"
          >
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title>{{ item.nodeExtension }} - {{ item.nodeName }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small v-show="textQueueType && active">close</v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    </v-sheet>

    <!-- Filter Agrupación -->
    <v-sheet v-show="isDetailRetail ">
    <v-menu
        max-height="250"
        v-model="menuFilterGroup"
        bottom
        offset-y
        :close-on-content-click="false">

      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            v-bind="attrs"
            v-on="on"
        >
          <v-badge :color="textGroup ? 'success' : 'transparent' " dot :bordered="!!textGroup">
            <v-icon color="primary" class="mr-2" left>
              mdi-format-list-bulleted
            </v-icon>
            <span v-show="!isMobile"> {{ $t('Global.Reports.groups') }} </span>
          </v-badge>
        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group
            color="background"
            class="v-text-search-custom">
          <v-list-item>
            <v-text-field
                color="background"
                dense
                class="neu-input"
                v-model="searchGroup"
                :label="searchLabelText"
                hide-details/>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="background" v-model="modelGroup">
          <v-list-item
              max-height="240"
              style="overflow-y: auto;"
              color="primary"
              v-for="(item, index) in groupList"
              :key="index.nodeId"
              @click="changeGroupData(item)"
          >
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title>{{item.groupName}}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small v-show="textGroup && active">close</v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    </v-sheet>
    <!-- reset init data  -->
    <v-menu
        bottom
        offset-y
        :close-on-content-click="false">
      <template v-slot:activator="{ on: onMenu, attrs: onAttrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
            <v-btn
                small
                class="neu-glow mr-3"
                color="background"
                v-bind="{...onAttrs, ...attrsTooltip}"
                v-on="{...onMenu, ...onTooltip}"
                @click="initFilterValues()"
            >
              <v-icon color="primary" class="mr-2" left>
                mdi-backup-restore
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Global.Reports.reset-data') }}</span>
        </v-tooltip>
      </template>
    </v-menu>
  </v-system-bar>
  </v-sheet>
</template>
<script>
import {mapGetters} from "vuex";
import moment from "moment";

// HOURS_23_MILI eliminado: inputDatePicker ya añade '23:59:59' a datesPiker[1],
// por lo que no se debe sumar ningún offset adicional al 'to' en rangeCustom().

export default {
  name: 'report-filters',
  props: {
    reportTypes: {
      type: Array,
      default: ()=> []
    },
    granularityTypes: {
      type: Array,
      default: ()=> []
    },
    agents: {
      type: Array,
      default: ()=> []
    },
    queues: {
      type: Array,
      default: ()=> []
    },
    groups: {
      type: Array,
      default: ()=> []
    }
  },
  data() {
    return {

      requestData: {
        sendRequest: false,
        report: {},
        granularity: {},
        date: {},
        agent: {},
        group: {}
      },

      menuFilterReportType: false,
      textReportType: '',
      modelReportType: null,
      searchReportType: '',

      menuFilterGranularityType: false,
      textGranularityType: '',
      modelGranularityType: null,
      searchGranularityType: '',
      isReportDetailRecord: false,

      menuFilterAgentType: false,
      searchAgentType: '',
      modelAgentType: null,
      textAgentType: '',

      menuFilterTlf:false,
      tlf: '',

      menuFilterQueueType: false,
      searchQueueType: '',
      modelQueueType: null,
      textQueueType: '',

      menuFilterGroup: false,
      searchGroup: '',
      modelGroup: null,
      textGroup: '',

      menuFiltersDate: false,
      menuDatePicker: false,
      dateSelected: {},
      datesPiker: [],
      timeRangesExpandable: true,
      modelFixedDate: 0,
      showDateFilter: null,
      searchRange: '',
      validTelephoneSpanishNumber: v => !!v && v.match(/^(\+)?\d{0,15}$/) ? true : this.$t('Global.FormRules.validTelephoneSpanishNumber'),
    }
  },
  computed: {
    ...mapGetters({localeGeneral: "locale"}),
    isValidTelephoneSpanishNumber(){
      return !!this.tlf && this.tlf.match(/^(\+)?\d{0,15}$/)
    },
    isDetailRetail(){
      return !!this.isReportDetailRecord
    },
    isModelReportSelected() {
      return this.modelReportType >= 0
    },
    isMobile() {
      return !this.$vuetify.breakpoint.smAndUp
    },
    reportTypesList() {
      return this.reportTypes?.filter((i) => i.reportTypeName?.toLocaleLowerCase().includes(this.searchReportType))
    },
    granularityTypesList() {
      return this.granularityTypes?.filter((i) => i.granularityTypeName?.toLocaleLowerCase().includes(this.searchGranularityType)).sort((a,b) => b.granularityTypeId - a.granularityTypeId );
    },
    agentsList() {
      return this.agents?.filter((i) => i.agentExtension?.toLocaleLowerCase().includes(this.searchAgentType) || i.agentName?.toLocaleLowerCase().includes(this.searchAgentType))
    },
    queuesList() {
      return this.queues?.filter((i) => i.nodeExtension?.toLocaleLowerCase().includes(this.searchQueueType) || i.nodeName?.toLocaleLowerCase().includes(this.searchQueueType))
    },
    groupList() {
      return this.groups?.filter((i) => i.groupName?.toLocaleLowerCase().includes(this.searchGroup))
    },
    searchLabelText() {
      return this.$t('Global.Reports.search')
    },
    textDate() {
      return this.dateSelected?.text || this.$t("Global.Reports.dates")
    },
    dateRangeCSS() {
      return this.isMobile ? '' : 'date-range-container-flex'
    },
    isAllDatesPikerSelected() {
      return this.datesPiker.length === 2
    },
    showTimeRangesExpandable() {
      return !this.isMobile || this.timeRangesExpandable
    },
    fromLabelText() {
      return this.$t('Global.Reports.from')
    },
    toLabelText() {
      return this.$t('Global.Reports.to')
    },
    isDifferentDatesSelected() {
      return !(this.isAllDatesPikerSelected && this.datesPiker[0] !== this.datesPiker[1])
    },
    dateFrom() {
      const date = new Date(this.datesPiker[0]).getTime() < new Date(this.datesPiker[1]).getTime() ? this.datesPiker[0] : this.datesPiker[1]
      return this.isAllDatesPikerSelected ? moment(date).format('DD/MM/YY HH:mm:ss') : ''
    },
    dateTo() {
      const date = new Date(this.datesPiker[1]).getTime() > new Date(this.datesPiker[0]).getTime() ? this.datesPiker[1] : this.datesPiker[0]
      return this.isAllDatesPikerSelected ? moment(date).format('DD/MM/YY HH:mm:ss') : ''
    },
    dateList() {
      return this.dates.filter((i) => i.text.toLocaleLowerCase().includes(this.searchRange))
    },
    isAllSelected(){
      return  !this.isDetailRetail
          ? !!this.requestData?.report?.reportTypeId && !!this.requestData?.date?.from && !!this.requestData?.date?.to && !!this.requestData?.granularity?.granularityTypeId
          : !!this.requestData?.report?.reportTypeId && !!this.requestData?.date?.from && !!this.requestData?.date?.to
    }
  },
  watch: {
    reportTypes:{
      handler() {
        this.initFilterValues()
      },
      deep: true
    },
  },
  methods: {
    changeReportTypeData(data) {
      this.initFilterValues()
      if(this.textReportType === data.reportTypeName){
        this.textReportType = ''
        this.requestData.report = {}
      }else{
        this.isReportDetailRecord = data.reportTypeId === 5 ;
        this.textReportType = data.reportTypeName
        this.requestData.report = data
      }
      this.requestData.sendRequest = this.isAllSelected
      this.menuFilterReportType = false
      this.$emit('dataFilters', this.requestData)
    },
    changeAgentData(data) {
      if(this.textAgentType === data.agentName){
        this.textAgentType = ''
        this.requestData.agent = {}
      }else{
        if(this.textQueueType != ''){
          this.textQueueType = ''
          this.requestData.queue = {}
          this.menuFilterQueueType = false
          this.modelQueueType = {}
        }
        if(this.textGroup != ''){
          this.textGroup = ''
          this.requestData.group = {}
          this.menuFilterGroup = false
          this.modelGroup = {}
        }
        this.textAgentType = data.agentName
        this.requestData.agent = data
      }
      this.menuFilterAgentType = false
      this.$emit('dataFilters', this.requestData)
    },
  changeQueueData(data) {
      if(this.textQueueType === data.nodeName){
        this.textQueueType = ''
        this.requestData.queue = {}
      }else{
        if(this.textAgentType != ''){
          this.textAgentType = ''
          this.requestData.agent = {}
          this.menuFilterAgentType = false
          this.modelAgentType = {}
        }
        if(this.textGroup != ''){
          this.textGroup = ''
          this.requestData.group = {}
          this.menuFilterGroup = false
          this.modelGroup = {}
        }
        this.textQueueType = data.nodeName
        this.requestData.queue = data
      }
      this.menuFilterQueueType = false
      this.$emit('dataFilters', this.requestData)
    },
    changeGroupData(data) {
      if(this.textGroup === data.groupName){
        this.textGroup = ''
        this.requestData.group = {}
      }else{
        if(this.textAgentType != ''){
          this.textAgentType = ''
          this.requestData.agent = {}
          this.menuFilterAgentType = false
          this.modelAgentType = {}
        }
        if(this.textQueueType != ''){
          this.textQueueType = ''
          this.requestData.queue = {}
          this.menuFilterQueueType = false
          this.modelQueueType = {}
        }
        this.textGroup = data.groupName
        this.requestData.group = data
      }
      this.menuFilterGroup = false
      this.$emit('dataFilters', this.requestData)
    },
    clearTlf(){
      this.tlf = ''
      this.changeTlf(true)
    },
    changeTlf(showMenuFilterTlf = false) {
      this.requestData.tlf = !this.tlf ? '' : this.tlf;

      this.menuFilterTlf = showMenuFilterTlf
      this.$emit('dataFilters', this.requestData)
    },
    changeGranularityTypeData(data) {
      if(this.textGranularityType === data.granularityTypeName){
        this.textGranularityType = ''
        this.requestData.granularity = {}
      }else{
        this.textGranularityType = data.granularityTypeName
        this.requestData.granularity = data
      }
      this.requestData.sendRequest = this.isAllSelected
      this.menuFilterGranularityType = false
      this.$emit('dataFilters', this.requestData)
    },
    changeDateData(data) {
      this.menuFiltersDate = false
      this.dateSelected = data
      this.requestData.date = data
      this.requestData.sendRequest = this.isAllSelected
      this.$emit('dataFilters', this.requestData)
    },
    inputDatePicker(listDate) {
      const status = listDate.length === 1
      if (status) {
        this.datesPiker[0] = listDate[0].toString() + ' 00:00:00'
      } else {
        this.datesPiker[1] = listDate[1].toString() + ' 23:59:59'
      }
      this.menuDatePicker = status
    },
    rangeCustom() {
      this.menuFiltersDate = false;
      const dateTimeFirst = Math.round(new Date(this.datesPiker[0]).getTime());
      const dateTimeSecond = Math.round(new Date(this.datesPiker[1]).getTime());
      const from = dateTimeFirst < dateTimeSecond ? dateTimeFirst : dateTimeSecond;
      const to = dateTimeFirst > dateTimeSecond ? dateTimeFirst : dateTimeSecond;

      let data = {...this.dateSelected}
      data['text'] = `${this.$t('Global.Reports.from')} ${this.dateFrom} ${this.$t('Global.Reports.to')} ${this.dateTo}`
      data['from'] = from
      data['to'] = to
      this.changeDateData(data)
    },
    rangeFixed(data) {
      this.datesPiker = []
      this.changeDateData(data)
    },
    searchSpeedRangesLabelText() {
      return this.$t('Global.Reports.search-speed-ranges')
    },
    initFilterValues() {

      this.requestData = {
        sendRequest: false,
        report: {},
        granularity: {},
        date: {},
        tlf: '',
        agent: {},
        queue: {}
      }

      this.isReportDetailRecord = false;

      this.modelReportType = null
      this.requestData.report = {}
      this.textReportType = ''
      this.searchReportType = ''

      this.modelAgentType = null
      this.textAgentType = ''
      this.searchAgentType = ''

      this.modelQueueType = null
      this.textQueueType = ''
      this.searchQueueType = ''

      this.menuFilterTlf = null
      this.tlf = ''

      this.modelGranularityType = null
      this.textGranularityType = ''
      this.searchGranularityType = ''

      this.searchRange = ''
      this.datesPiker.length = 0
      this.dateSelected = {}

      this.requestData.sendRequest = false;

      this.$emit('dataFilters', this.requestData)

    },
    closeMenuFilterDate(){
      this.menuFiltersDate = false
      this.datesPiker.length = 0
      this.dateSelected = {}
      this.requestData.date = {}
      this.requestData.sendRequest = false;
      this.$emit('dataFilters', this.requestData)
    },
    cleanMenuDatePicker(){
      const controlDate = this.dateSelected?.from && this.dateSelected?.to
      if(!controlDate){
        this.datesPiker.length = 0
        this.requestData.date = {}
        this.$emit('dataFilters', this.requestData)
      }
    }
  },
  mounted() {
    this.initFilterValues()
  }
}
</script>
<style>

.card-dates {
  overflow-y: hidden;
  overflow-x: hidden;
}
.v-text-field-custom {
  width: 65vw;
}

.v-text-search-custom {
  position: sticky;
  top:0;
  opacity: 1;
  z-index:10;
}

.date-range-container-flex {
  display: flex;
  flex-direction: row;
  width: 100%;
}
</style>
